import axios from "axios";
import React, { useEffect, useState } from "react";
import ReactScrollWheelHandler from "react-scroll-wheel-handler";
const VirtualTour = () => {
  useEffect(() => {
    getSellers();
  }, []);

  const [scrollIndex, setSecrollIndex] = useState(0);
  const [shops, setShops] = useState([]);
  const [hasClicked, sethasClicked] = useState(false);

  const getSellers = () => {
    axios
      .get(" https://api.ghalichin.com/sellers/api/list")
      .then((res) => {
        setShops(res?.data);
      })
      .catch(() => {});
  };

  return (
    <ReactScrollWheelHandler
      upHandler={(e) =>
        setSecrollIndex(scrollIndex === 0 ? 30 : scrollIndex - 10)
      }
      downHandler={(e) =>
        setSecrollIndex(scrollIndex === 30 ? 0 : scrollIndex + 10)
      }
    >
      <div
        style={{
          backgroundColor: "#8b7854",
          backgroundPosition: "center",
          backgroundImage: `url(/static/img/virtualtour1.png)`,
          width: "100%",
          height: "100vh",
          minHeight: "100vh",
          backgroundSize: "cover",
          display: "flex",
          position: "relative",
          justifyContent: "center",
          overflowY: "hidden",
          //transform: scrollIndex ?`scale(${1 + scrollIndex/100})` : 0
          transform: hasClicked ? "scale(1.5)" : "none",
          transition: "all 1.5s",
        }}
      >
        <div
          style={{
            backgroundImage: `url(/static/img/virtualtour2.png)`,
            backgroundPosition: "center",
            width: 760,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            display: "flex",
            padding: 20,
            position: "relative",
            zIndex: 1,
          }}
          onClickCapture={() => setSecrollIndex(10)}
        >
          <div
            style={{
              backgroundImage: `url(/static/img/corner1.png)`,
              backgroundPosition: "center",
              width: 65,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              display: "flex",
              filter: scrollIndex === 10 ? "saturate(2.5)" : "none",
            }}
          ></div>

          <div
            style={{
              backgroundImage: `url(/static/img/corner3.png)`,
              backgroundPosition: "center",
              width: 65,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              display: "flex",
              position: "absolute",
              top: 545,
              bottom: 0,
              right: 25,
              filter: scrollIndex === 10 ? "saturate(2.5)" : "none",
            }}
          ></div>

          <div
            style={{
              backgroundImage: `url(/static/img/virtualtour3.png)`,
              backgroundPosition: "center",
              width: 570,
              marginTop: 159,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              display: "flex",
              padding: 4,
              position: "relative",
            }}
            onClickCapture={() => {
              setSecrollIndex(20);
            }}
          >
            <div
              style={{
                backgroundImage: `url(/static/img/corner1.png)`,
                backgroundPosition: "center",
                width: 49,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                display: "flex",
                filter: scrollIndex === 20 ? "saturate(2.5)" : "none",
              }}
            ></div>
            <div
              style={{
                backgroundImage: `url(/static/img/corner3.png)`,
                backgroundPosition: "center",
                width: 49,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                display: "flex",
                position: "absolute",
                top: 390,
                bottom: 0,
                right: 10,
                filter: scrollIndex === 20 ? "saturate(2.5)" : "none",
              }}
            ></div>
            <div
              style={{
                backgroundImage: `url(/static/img/virtualtour4.png)`,
                backgroundPosition: "center",
                width: 438,
                marginTop: 105,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                display: "flex",
                position: "relative",
              }}
              onClickCapture={() => {
                setSecrollIndex(30);
              }}
            >
              <div
                style={{
                  backgroundImage: `url(/static/img/corner1.png)`,
                  backgroundPosition: "center",
                  width: 37,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  display: "flex",
                  filter: scrollIndex === 30 ? "saturate(2.5)" : "none",
                }}
              ></div>
              <div
                style={{
                  backgroundImage: `url(/static/img/corner3.png)`,
                  backgroundPosition: "center",
                  width: 37,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  display: "flex",
                  position: "absolute",
                  top: 288,
                  bottom: 0,
                  right: 8,
                  filter: scrollIndex === 30 ? "saturate(2.5)" : "none",
                }}
              ></div>
              <div
                style={{
                  backgroundImage: `url(/static/img/virtualtour4.png)`,
                  backgroundPosition: "center",
                  width: 324,
                  marginTop: 70,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  display: "flex",
                  filter: scrollIndex >= 10 ? "saturate(2.35)" : "none",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  textAlign: "center",
                  cursor: "pointer",
                }}
                onClickCapture={() => {
                  if (scrollIndex >= 10) {
                    if (scrollIndex / 10 == 1) {
                      sethasClicked(true);
                      window.location.href =
                        "https://shop.ghalichin.com/royayekamal";
                      setSecrollIndex(10);
                    } else if (scrollIndex / 10 == 2) {
                      sethasClicked(true);
                      setSecrollIndex(20);
                      window.location.href =
                        "https://shop.ghalichin.com/sarcheshmeh";
                    } else {
                      sethasClicked(true);
                      setSecrollIndex(30);
                      window.location.href =
                        "https://shop.ghalichin.com/ghalichin";
                    }
                  }
                }}
              >
                {shops.map((shop, index) =>
                  index + 1 == scrollIndex / 10 ? shop.name : ""
                )}
              </div>
              <div
                style={{
                  backgroundImage: `url(/static/img/corner2.png)`,
                  backgroundPosition: "center",
                  width: 37,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  display: "flex",
                  filter: scrollIndex === 30 ? "saturate(2.5)" : "none",
                }}
              ></div>
              <div
                style={{
                  backgroundImage: `url(/static/img/corner4.png)`,
                  backgroundPosition: "center",
                  width: 37,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  display: "flex",
                  position: "absolute",
                  top: 288,
                  bottom: 0,
                  left: 8,
                  filter: scrollIndex === 30 ? "saturate(2.5)" : "none",
                }}
              ></div>
            </div>
            <div
              style={{
                backgroundImage: `url(/static/img/corner2.png)`,
                backgroundPosition: "center",
                width: 49,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                display: "flex",
                filter: scrollIndex === 20 ? "saturate(2.5)" : "none",
              }}
            ></div>
            <div
              style={{
                backgroundImage: `url(/static/img/corner4.png)`,
                backgroundPosition: "center",
                width: 49,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                display: "flex",
                position: "absolute",
                top: 390,
                bottom: 0,
                left: 8,
                filter: scrollIndex === 20 ? "saturate(2.5)" : "none",
              }}
            ></div>
          </div>

          <div
            style={{
              backgroundImage: `url(/static/img/corner2.png)`,
              backgroundPosition: "center",
              width: 65,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              display: "flex",
              filter: scrollIndex === 10 ? "saturate(2.5)" : "none",
            }}
          ></div>
          <div
            style={{
              backgroundImage: `url(/static/img/corner4.png)`,
              backgroundPosition: "center",
              width: 65,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              display: "flex",
              position: "absolute",
              top: 545,
              bottom: 0,
              left: 20,
              filter: scrollIndex === 10 ? "saturate(2.5)" : "none",
            }}
          ></div>
        </div>

        <div
          style={{
            width: "100%",
            height: 383,
            backgroundColor: "#8b7854",
            position: "absolute",
            bottom: 0,
            zIndex: 0,
          }}
        ></div>
      </div>
    </ReactScrollWheelHandler>
  );
};

export default VirtualTour;
